
import { Component, Vue } from 'vue-property-decorator';

// Capacitor
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';

@Component
export default class DeviceMethods extends Vue {
    // Computed properties
    get mobileLayout() {
        return this.$store.getters['Viewport/mobileLayout'];
    }

    get tabletLayout() {
        return this.$store.getters['Viewport/tabletLayout'];
    }

    get desktopLayout() {
        return this.$store.getters['Viewport/desktopLayout'];
    }

    get shelfVisible() {
        return this.$store.getters['Viewport/shelfVisible'];
    }

    get deviceClass() {
        return {
            'hococo-mobile': (this.mobileLayout || this.tabletLayout),
            'hococo-desktop': (this.desktopLayout),
            'h-auto': this.$store.getters['Viewport/getIsRequireAutoHeight'],
        };
    }

    get currentView() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    get isTenant() {
        const user = this.$store.getters['User/getUser'];

        return user && user.isTenant;
    }

    public async device() {
        return Device.getInfo();
    }

    public async app() {
        return App.getInfo();
    }

    public async deviceLanguage() {
        return Device.getLanguageCode();
    }
}
